


































































import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import ImageUpload from '@/views/molecules/ImageUpload.vue'
import RightBox from '@/views/molecules/RightBox.vue'
import SearchButton from '@/views/atoms/SearchButton.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'
import GreenButton from '@/views/atoms/GreenButton.vue'
import Global from '@/common/global.js'

export default
  components: {
    Popup
    BlueButton
    ImageUpload
    RightBox
    SearchButton
    CheckBox
    ErrorLabel
    GreenButton
  }

  props:
    title:
      type: String
      default: ''
    fileType:
      type: String
      default: ''
    export_id: 
      type: String
      default: ''
    notSeve:
      type: Boolean
      default: true
    nameSelect:
      type: Boolean
      default: false
    aclSave:
      type: Boolean
      default: true
    mblSave:
      type: Boolean
      default: true
    hblSave:
      type: Boolean
      default: true
    isPartner:
      type: Boolean
      default: false
    booking:
      type: String
      default: ''
    shipper_name:
      type: String
      default: ''
    complete_flg:
      type: String
      default: '0'

  data: () ->
    fileList: [],
    deleteId: [],
    mailList: store.getters.mailList,
    mailaddressList: [],
    postaddress: [],
    afterSumit: false,
    key: 0,
    address: '',
    id: '',
    downloadIds: [],
    completeFlg: '0'

  created: () ->
    @completeFlg = @upChecked()
    api = new ApiClient()
    param = 
      export_id: Number(@export_id)
    data = await api.post('/fc/' + @fileType + '/list', param)
    @fileList = data.list.files
    for rows, index in await @mailList
      @mailaddressList.push(rows)
    if @notSeve
      @_addImageData()

    postParam =
      detail: data.list
    store.dispatch('setDetailParam', postParam)

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    save_click: () ->
      files = store.getters.getPostParam.files
      i = files.length - 1
      if i >= 0 && files[i]['file_name'] == ""
        files.pop()
      @afterSumit = true
      param =
        export_id: Number(@export_id)
        files: files
        deleteIds: @deleteId
        mail_list: @postaddress
      api = new ApiClient()
      data = await api.post('/fc/' + @fileType + '/save', param)
      if data.errors.length == 0
        store.dispatch('setErrors', [])
        if store.getters.getPostParam.custom_materials_complete_flg != undefined
          param =
              id: @export_id
              custom_materials_complete_flg: store.getters.getPostParam.custom_materials_complete_flg
          api = new ApiClient()
          await api.post('/fc/save', param)
        @$emit('click')
      store.dispatch('setErrors', data.errors)
      @afterSumit = false

    addImageRow: (e) ->
      @_addImageData()

    _addImageData: () ->
      @fileList.push(
        'file_name': ''
        'file': ''
        'kind': '1'
      )

    deleteImageRow: (idx) ->
      deleteId = @fileList[idx].id
      if deleteId
        @deleteId.push('id': deleteId)
      @fileList.splice(idx, 1)

    imageDataChange: (e) ->
      @fileList[e.index][e.name] = e.val
      if (e.index + 1) == @fileList.length
        @_addImageData()

    addressChange: (e) ->
      @address = e

    click: (e) ->
      @key = e

    addressCheck: (e) ->
      if e
        mailaddress = @postaddress.map (el) -> el.mailaddress
        index = mailaddress.indexOf(@address)
        if index < 0
          @postaddress.push('mailaddress': @address)
      else
        mailaddress = @postaddress.map (el) -> el.mailaddress
        index = mailaddress.indexOf(@address)
        @postaddress.splice(index, 1)
    downloadChange: (e) ->
      @id = e
    downloadChecked: (e) ->
      if e
        ids = @downloadIds.map (el) -> el.id
        index = ids.indexOf(Number(@id))
        if index < 0
          @downloadIds.push('id': Number(@id))
      else
        ids = @downloadIds.map (el) -> el.id
        index = ids.indexOf(Number(@id))
        @downloadIds.splice(index, 1)
    downloadClick: () ->
      param =
        download_ids: @downloadIds
      api = new ApiClient()
      data = await api.post('/download/' + @fileType, param)
      if data.errors
        alert(data.errors.download)
      else if data.file.data != ''
        fileData = atob(data.file.data.replace(/^.*,/, ''))
        buffer = new Uint8Array(fileData.length)
        for i in [0..fileData.length]
          buffer[i] = fileData.charCodeAt(i)
        file = new File([buffer.buffer], data.file.name, {type: 'application/zip'});
        blob = new Blob([file], { type: 'application/zip' })
        link = document.createElement('a')
        link.download = data.file.name
        link.href = URL.createObjectURL(blob)
        link.click()
    isHanEisu: (title) ->
      if title.match(/^[A-Za-z0-9\s^./.$]*$/)
        return true
      else
        return false
    upChange: (e) ->
      if e
        v = 1
      else
        v = 0
      store.dispatch('setPostParam', {label: 'custom_materials_complete_flg', value: v, index: null, group: null})
    upChecked: () ->
      if @complete_flg == '1'
        return true
      return false
  }
